import Spinner from 'spin.js';
import loadGNB from '../common/gnb.wrapper';

loadGNB().then(GNB => {
  $(() => {
    try {
      GNB.data = Ridi.globals;
    } catch (err) {
      GNB.data = {};
    }

    const clickEvent = GNB.data.isPc ? 'click' : 'touchstart';

    /**
     * 첫 mouseover 시에 ajax요청
     */
    $('.menu_user').one('touchstart click mouseover', () => {
      GNB.refreshMyRidiLayer();
    });

    $('.menu_cart').one('touchstart click mouseover', () => {
      GNB.refreshCartLayer();
    });

    if (GNB.data.isPc) {
      $('html').click(() => {
        $('#all_menu').fadeOut('fast');
      });

      const $defaultActiveGeneralMenu = $('.js_general_menu_wrapper.active');
      $('.js_general_menu_wrapper').hover(
        () => {
          $defaultActiveGeneralMenu.removeClass('active');
        },

        () => {
          $defaultActiveGeneralMenu.addClass('active');
        },
      );

      $('.menu_user').hover(() => {
        $('#divMyMenuLayer').css('display', 'block');
      }, () => {
        $('#divMyMenuLayer').css('display', 'none');
        $('#browser_ie8 #divMyMenuLayer').css('display', 'none');
      });

      $('.menu_cart').hover(() => {
        $('#cartMenuPopup').css('display', 'block');
      }, () => {
        $('#cartMenuPopup').css('display', 'none');
      });
    } else {
      const $noti = $('.menu_noti .GNB_popup');
      const $myridi = $('.menu_user .GNB_popup');
      const $cart = $('.menu_cart .GNB_popup');
      const popups = [$noti, $myridi, $cart];
      const toggle = function ($popup) {
        for (let i = 0; i < popups.length; ++i) {
          if (popups[i] === $popup) {
            $popup.toggle();
          } else {
            popups[i].hide();
          }
        }
      };

      $('html').on(clickEvent, () => {
        for (let i = 0; i < popups.length; ++i) {
          popups[i].hide();
        }

        $('#all_menu').fadeOut();
      });

      const _fnStopPropagation = function (e) {
        e.stopPropagation();
      };

      for (let i = 0; i < popups.length; ++i) {
        popups[i].on(clickEvent, _fnStopPropagation);
      }

      // gnb 알림센터, 마이리디, 카트, 위시리스트 페이지 이동하지 않도록 처리!
      $('#gnb_noti_link, #gnb_myridi_link, #gnb_cart_link').attr('href', '#');

      $('#gnb_myridi_link').on(clickEvent, e => {
        e.stopPropagation();
        toggle($myridi);
      });

      $('#gnb_cart_link').on(clickEvent, e => {
        e.stopPropagation();
        toggle($cart);
      });

      $('.js_general_menu_title').on(clickEvent, function (e) {
        $('.js_general_menu_wrapper.active').removeClass('active');
        $(this).closest('.js_general_menu_wrapper').addClass('active');
        e.preventDefault();
      });
    }
    /**
     * 전체분야 메뉴 제어
     */
    $('#show_all_menu_btn').on(clickEvent, e => {
      $('#all_menu').fadeIn('fast');
      e.stopPropagation();
    });

    $('#hide_all_menu_btn').on(clickEvent, e => {
      $('#all_menu').fadeOut('fast');
      e.stopPropagation();
    });

    $('.all_menu_wrapper').on(clickEvent, e => {
      e.stopPropagation();
    });
  }); // end of document.ready
});



// WEBPACK FOOTER //
// ./ridi/ridi.gnb.js